import {
  hasMakeRequestBridge,
  ingestData,
  isMobile,
  makeRequest,
} from "../../../bridges/BridgeServices";
import { bridgePromiseWrapper } from "../../../bridges/BridgePromise/bridgePromise";
import { setTransactionsLoading } from "../../../store/slices/recentActivity/recentActivity.setters";
import {
  API_ENUMS,
  API_METHODS,
} from "../../../bridges/bridgeConstants";
import { createApiData } from "../../service.helper";
import { EVENTS } from "../../../utils/constants";
import { GET_TRANSACTIONS_URL } from "../recentActivity.url";

const fetchTransactions = async (nextPageToken = null) => {
  try {
    if (isMobile() && !hasMakeRequestBridge()) return;

    const apiData = () => {
      return createApiData(
        API_METHODS.POST,
        GET_TRANSACTIONS_URL(nextPageToken)
      );
    };

    setTransactionsLoading(true);
    const resp = await bridgePromiseWrapper(
      makeRequest(
        {
          ...apiData(),
        },
        API_ENUMS.GET_TRANSACTIONS,
        () => setTransactionsLoading(false)
      )
    );
  } catch (err) {
    ingestData({
      name: EVENTS.FETCH_TRANSACTION_ERROR,
    });
  }
};

export default fetchTransactions;
